import { useIntl } from 'react-intl';
import { Card, CardContent, CardHeader, Divider, Stack, Typography } from '@packages/shared';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import type { ArticleServicesCurrencyFragmentFragmentDoc } from '@packages/gql/generated/shopping/ArticleServicesCurrencyFragmentFragmentDoc';
import { ArticleServicesFragmentFragmentDoc } from '@packages/gql/generated/shopping/ArticleServicesFragmentFragmentDoc';
import { articleServicesMessages } from './messages';
import { ArticleServicesCluster } from './ArticleServicesCluster';
import { BadgeDV } from '../BadgeDV';

/* GraphQL */ `
  fragment ArticleServicesFragment on APlus {
    clusters {
      ...ArticleServicesClusterFragment
    }
  }
`;

export type ArticleServicesProps = {
  data: FragmentType<typeof ArticleServicesFragmentFragmentDoc>;
  /* should be in aPlus price value */
  currencyData: FragmentType<typeof ArticleServicesCurrencyFragmentFragmentDoc>;
};

export const ArticleServices = ({ data, currencyData }: ArticleServicesProps) => {
  const { clusters } = getFragmentData(ArticleServicesFragmentFragmentDoc, data);

  const { formatMessage } = useIntl();

  if (clusters.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader
        title={
          <Stack direction="row" alignItems="center" gap={2}>
            <BadgeDV text={formatMessage(articleServicesMessages.articleServicesCardTip)} />
            <Typography variant="h5">
              {formatMessage(articleServicesMessages.articleServicesCardHeadline)}
            </Typography>
          </Stack>
        }
        sx={{ borderBottom: 1, borderColor: 'grey.main', py: 1, px: 2 }}
      />
      <CardContent>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        >
          <Stack spacing={1} divider={<Divider />}>
            {clusters.map(
              (cluster) =>
                cluster && (
                  <ArticleServicesCluster
                    data={cluster}
                    currencyData={currencyData}
                    key={JSON.stringify(cluster)}
                  />
                ),
            )}
          </Stack>
        </form>
      </CardContent>
    </Card>
  );
};
